<mat-card class="p-0 mat-elevation-z0">
  <mat-card-header>
    <mat-card-title>Add content</mat-card-title>
  </mat-card-header>
  <mat-card-content class="m-0">
    <app-filter-content-list
      (filter)="filter($event)"
      [deliveryTargetCodes]="deliveryTargetCodes"
    ></app-filter-content-list>
    <!-- TODO PROTRACTOR: Leaving class content-bulk-actions so protractor tests dont break -->
    <div
      class="flex flex-wrap items-center p-3 bg-project-1500 content-bulk-actions"
      *ngIf="contentDataSource.data.length"
    >
      <mat-checkbox
        (change)="
          $event ? masterToggle(contentSelection, contentDataSource) : null
        "
        [checked]="
          contentSelection.hasValue() &&
          isAllSelected(contentSelection, contentDataSource)
        "
        [disabled]="!isSelectAllCheckboxEnabled()"
        [indeterminate]="
          contentSelection.hasValue() &&
          !isAllSelected(contentSelection, contentDataSource)
        "
        [aria-label]="'Select all'"
        color="primary"
      >
        Select all
        <span *ngIf="contentSelection.selected.length"
          >({{ contentSelection.selected.length }})</span
        >
      </mat-checkbox>
      <span class="flex-1"></span>
      <button
        mat-stroked-button
        class="mx-2"
        [disabled]="
          !contentSelection.hasValue() &&
          !isAllSelected(contentSelection, contentDataSource)
        "
        (click)="addToContentList(contentSelection.selected)"
      >
        <i class="icon icon-plus"></i> Add to list
      </button>
      <button
        mat-stroked-button
        (click)="pinAndAddToContentList(contentSelection.selected)"
        [disabled]="
          !contentSelection.hasValue() &&
          !isAllSelected(contentSelection, contentDataSource)
        "
      >
        <i class="icon icon-thumb-tack"></i> Pin to list
      </button>
    </div>
    <app-processing-boundary
      [isProcessing]="isProcessing"
      [showEmptyResultMsg]="!contentDataSource?.data?.length"
      [emptyResultMsg]="'No content is available'"
    >
      <table
        mat-table
        [dataSource]="contentDataSource"
        matSort
        class="w-full p-3"
      >
        <ng-container matColumnDef="select">
          <td mat-cell *matCellDef="let content">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? contentSelection.toggle(content) : null"
              [checked]="isContentSelected(content)"
              color="primary"
              *ngIf="!content.isPinned || !content.isInContentList"
            >
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="title">
          <td
            mat-cell
            *matCellDef="let content; let index = index; let first = first"
          >
            <div class="py-2">
              <strong
                ><a
                  *ngIf="
                    !(isEnabledForContentType$(content.contentType) | async)
                  "
                  [href]="'/#/content/' + content.contentId"
                  >{{ content.title }}</a
                >
                <a
                  *ngIf="isEnabledForContentType$(content.contentType) | async"
                  [routerLink]="
                    getRouteForContentType(
                      content.contentType,
                      content.contentId,
                      content.status
                    )
                  "
                  >{{ content.title }}</a
                ></strong
              >
              <p>
                <span class="m-0">{{
                  content.publishedDate | formatdate
                }}</span>
                <span
                  *ngIf="content.isInContentList"
                  class="inline-flex flex-row justify-center items-center py-[10px] px-[6px] relative w-max h-4 bg-project-1200 rounded-[3px] grow-0 my-0 mx-2 italic font-[550] text-sm leading-[9px] text-project-500"
                  >Added</span
                >
                <span
                  *ngIf="content.isPinned"
                  class="inline-flex flex-row justify-center items-center py-[10px] px-[6px] relative w-max h-4 bg-project-1200 rounded-[3px] grow-0 my-0 mx-2 italic font-[550] text-sm leading-[9px] text-project-500"
                  >Pinned</span
                >
              </p>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="pin">
          <td mat-cell *matCellDef="let content">
            <button
              mat-icon-button
              [disabled]="content.isPinned"
              (click)="pinAndAddToContentList([content])"
              matTooltip="Pin"
            >
              <i
                class="icon icon-thumb-tack"
                [ngClass]="{ selected: content.isPinned }"
              ></i>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="add">
          <td mat-cell *matCellDef="let content">
            <button
              mat-icon-button
              [disabled]="content.isInContentList"
              (click)="addToContentList([content])"
              matTooltip="Add"
            >
              <i class="icon icon-plus"></i>
            </button>
          </td>
        </ng-container>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{
            'content-exist-in-content-list': row.isInContentList,
            'content-pinned': row.isPinned
          }"
        ></tr>
      </table>
    </app-processing-boundary>
  </mat-card-content>
  <mat-card-footer class="m-0">
    <div
      class="flex items-center justify-between px-4 py-3 border-t bg-project-600 border-t-project-700"
    >
      <div>
        <mat-form-field
          [floatLabel]="'never'"
          appearance="outline"
          class="w-16 text-sm leading-[0.99rem] content-lists__page-select"
        >
          <mat-select [formControl]="pageSizeFilter">
            <mat-option *ngFor="let page of pagingOptions" [value]="page">
              {{ page }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="pl-3">per page</span>
      </div>
      <div>
        <!-- TODO PROTRACTOR: Leaving content-lists__page-button so protractor test dont break -->
        <button
          class="content-lists__page-button bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
          (click)="cmsPaginationService.previousPage(contentDataSource)"
          [disabled]="!paginator.hasPreviousPage()"
        >
          Previous
        </button>
        <button
          *ngFor="let num of cmsPaginationService.pageNumbers"
          class="content-lists__page-button bg-none border border-project-50 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-white"
          (click)="cmsPaginationService.selectPage(contentDataSource, num)"
          [disabled]="cmsPaginationService.isActivePage(contentDataSource, num)"
          [ngClass]="{
            'content-lists__page-button--current':
              cmsPaginationService.isActivePage(contentDataSource, num)
          }"
        >
          {{ num }}
        </button>
        <button
          class="content-lists__page-button bg-none border border-project-100 font-semibold py-1.5 px-3 mr-1 cursor-pointer text-sm hover:bg-white text-dark disabled:pointer-events-none disabled:text-project-100 disabled:border-project-100"
          (click)="goToNextPage(contentDataSource)"
          [disabled]="allDataLoadedAndDisplayed(paginator?.hasNextPage())"
        >
          Next
        </button>
      </div>
    </div>
  </mat-card-footer>
</mat-card>

<mat-paginator
  [length]="contentDataSource.data.length"
  [pageSizeOptions]="pagingOptions"
  class="invisible"
>
</mat-paginator>
